/**
 * Snackbar Component
 * Provides toast-like notifications at the bottom of the screen
 */

// Build private API using IIFE (Module Pattern)
var Snackbar = (function () {
    const DEFAULT_TIMEOUT = 5000;

    var api = {
        /**
         * Initialize snackbar functionality
         */
        init: function () {
            api.bindEvents();
        },

        /**
         * Bind event handlers
         */
        bindEvents: function () {
            $(document).on('click', '[data-snackbar-close]', api.closeSnackbar);
            $(document).on('click', '[data-snackbar-action]', api.handleAction);
        },

        /**
         * Show a snackbar notification
         * @param {Object} options - Snackbar configuration
         * @param {string} options.type - Type of snackbar (success, error, default, warning, info)
         * @param {string} options.position - Position of snackbar (center, left, right)
         * @param {string} options.title - Optional title text
         * @param {string} options.message - Message text
         * @param {string} options.actionText - Optional action button text
         * @param {string} options.actionUrl - Optional action button URL
         * @param {number} options.duration - Auto-hide duration in milliseconds (default: 5000)
         * @param {string} options.id - Unique identifier for the snackbar
         * @returns {string} The snackbar ID
         */
        show: function (options) {
            var defaults = {
                type: 'default',
                position: 'center',
                duration: DEFAULT_TIMEOUT,
                id: 'snackbar-' + Date.now()
            };

            var config = $.extend({}, defaults, options);

            // Check if snackbar template exists in DOM
            var $existingSnackbar = $('.snackbar');
            
            if ($existingSnackbar.length === 0) {
                // eslint-disable-next-line no-console
                console.warn('Snackbar template not found. Make sure snackbar.isml is included in your template.');
                return null;
            }

            // Update existing snackbar content
            api.updateSnackbarContent($existingSnackbar, config);

            // Show with animation
            $existingSnackbar.addClass('snackbar--show');

            // Auto-hide if duration is set
            if (config.duration > 0) {
                setTimeout(function () {
                    api.hide(config.id);
                }, config.duration);
            }

            return config.id;
        },

        /**
         * Update snackbar content based on configuration
         * @param {jQuery} $snackbar - jQuery object of the snackbar
         * @param {Object} config - Snackbar configuration
         */
        updateSnackbarContent: function ($snackbar, config) {
            // Update type classes
            $snackbar.removeClass('snackbar--success snackbar--error snackbar--default snackbar--warning snackbar--info')
                .addClass('snackbar--' + config.type);
            
            // Update position classes
            $snackbar.removeClass('snackbar--center snackbar--left snackbar--right')
                .addClass('snackbar--' + config.position);
            
            // Update ID
            $snackbar.attr('data-snackbar-id', config.id);
            
            // Update title
            var $title = $snackbar.find('.snackbar__title');
            if (config.title) {
                if ($title.length === 0) {
                    $snackbar.find('.snackbar__text').prepend('<div class="snackbar__title subtitle-2"></div>');
                    $title = $snackbar.find('.snackbar__title');
                }
                $title.text(config.title).show();
            } else {
                $title.hide();
            }
            
            // Update message
            var $message = $snackbar.find('.snackbar__message');
            if (config.message) {
                if ($message.length === 0) {
                    $snackbar.find('.snackbar__text').append('<div class="snackbar__message small"></div>');
                    $message = $snackbar.find('.snackbar__message');
                }
                $message.text(config.message).show();
            } else {
                $message.hide();
            }
            
            
            /* 
            // Update action button
            var $actionBtn = $snackbar.find('.snackbar__action-btn');
            if (config.actionText && config.actionUrl) {
                if ($actionBtn.length === 0) {
                    $snackbar.find('.snackbar__actions').prepend('<a href="#" class="snackbar__action-btn btn btn-outline-light small" data-snackbar-action></a>');
                    $actionBtn = $snackbar.find('.snackbar__action-btn');
                }
                $actionBtn.text(config.actionText).attr('href', config.actionUrl).show();
            } else {
                $actionBtn.hide();
            } 
            */
        },

        /**
         * Hide a specific snackbar
         * @param {string} id - Snackbar ID
         */
        hide: function (id) {
            var $snackbar = $('[data-snackbar-id="' + id + '"]');
            if ($snackbar.length) {
                $snackbar.removeClass('snackbar--show').addClass('snackbar--hide');
                setTimeout(function () {
                    $snackbar.removeClass('snackbar--hide');
                }, 300); // Match animation duration
            }
        },

        /**
         * Hide all snackbars
         */
        hideAll: function () {
            $('.snackbar').removeClass('snackbar--show').addClass('snackbar--hide');
            setTimeout(function () {
                $('.snackbar').removeClass('snackbar--hide');
            }, 300); // Match animation duration
        },

        /**
         * Close snackbar event handler
         * @param {Event} e - Click event
         */
        closeSnackbar: function (e) {
            e.preventDefault();
            var $snackbar = $(e.target).closest('.snackbar');
            var id = $snackbar.attr('data-snackbar-id');
            api.hide(id);
        },

        /**
         * Handle action button click
         * @param {Event} e - Click event
         */
        handleAction: function (e) {
            // Let the link navigate naturally, but close the snackbar
            var $snackbar = $(e.target).closest('.snackbar');
            var id = $snackbar.attr('data-snackbar-id');
            
            // Close after a short delay to allow navigation
            setTimeout(function () {
                api.hide(id);
            }, 100);
        },

        /**
         * Show success snackbar
         * @param {string} message - Message text
         * @param {Object} options - Additional options
         * @returns {string} The snackbar ID
         */
        success: function (message, options) {
            var config = $.extend({}, options, {
                type: 'success',
                message: message
            });
            return api.show(config);
        },

        /**
         * Show error snackbar
         * @param {string} message - Message text
         * @param {Object} options - Additional options
         * @returns {string} The snackbar ID
         */
        error: function (message, options) {
            var config = $.extend({}, options, {
                type: 'error',
                message: message
            });
            return api.show(config);
        },

        /**
         * Show default snackbar
         * @param {string} message - Message text
         * @param {Object} options - Additional options
         * @returns {string} The snackbar ID
         */
        default: function (message, options) {
            var config = $.extend({}, options, {
                type: 'default',
                message: message
            });
            return api.show(config);
        },

        /**
         * Show warning snackbar
         * @param {string} message - Message text
         * @param {Object} options - Additional options
         * @returns {string} The snackbar ID
         */
        warning: function (message, options) {
            var config = $.extend({}, options, {
                type: 'warning',
                message: message
            });
            return api.show(config);
        },

        /**
         * Show info snackbar
         * @param {string} message - Message text
         * @param {Object} options - Additional options
         * @returns {string} The snackbar ID
        */
        info: function (message, options) {
            var config = $.extend({}, options, {
                type: 'info',
                message: message
            });
            return api.show(config);
        }
    };

    return api;
}());

// Export a single function for processInclude so it does not execute all API methods
module.exports = Snackbar;
